import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { AiFillHome } from "react-icons/ai";
import { IoIosArrowForward } from "react-icons/io";
import Card from "../../components/cards/Card";
import StyledHeadingText from "../../components/Fonts/StyledHeadingText";
import DashboardBarGraph from "../../components/Dashboard/DashboardBarGraph";
import Button from "../../components/buttons/Button";
import InputField from "../../components/inputFields/InputField";
import { getDeviceDropDownApi } from "../../services/apis/commodity";
import showAlert from "../../components/errorBoundries/Errors";
import Select from "../../components/inputFields/SelectField";
import DashboardLineChart from "../../components/Dashboard/DashboardLineChart";
import MapComponent from "../../components/Dashboard/MapComponent";
import { getDashboardApi } from "../../services/apis/dashboard";
import { getDeviceLogsApi } from "../../services/apis/device_logs";


const Dashboard = () => {
  const [cardData, setCardData] = useState([
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#1C64F2" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2002C18.3513 11.2002 17.5374 11.5373 16.9373 12.1375C16.3371 12.7376 16 13.5515 16 14.4002V33.6002C16 34.4489 16.3371 35.2628 16.9373 35.8629C17.5374 36.4631 18.3513 36.8002 19.2 36.8002H28.8C29.6487 36.8002 30.4626 36.4631 31.0627 35.8629C31.6629 35.2628 32 34.4489 32 33.6002V14.4002C32 13.5515 31.6629 12.7376 31.0627 12.1375C30.4626 11.5373 29.6487 11.2002 28.8 11.2002H19.2ZM24 33.6002C24.4243 33.6002 24.8313 33.4316 25.1314 33.1316C25.4314 32.8315 25.6 32.4245 25.6 32.0002C25.6 31.5758 25.4314 31.1689 25.1314 30.8688C24.8313 30.5688 24.4243 30.4002 24 30.4002C23.5757 30.4002 23.1687 30.5688 22.8686 30.8688C22.5686 31.1689 22.4 31.5758 22.4 32.0002C22.4 32.4245 22.5686 32.8315 22.8686 33.1316C23.1687 33.4316 23.5757 33.6002 24 33.6002V33.6002Z" fill="white" />
      </svg>,
      title: "Total Devices",
      count: "--",
    },
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#F2831C" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7936 11.4114C24.5518 11.2733 24.2783 11.2007 24 11.2007C23.7216 11.2007 23.4481 11.2733 23.2063 11.4114L12.0064 17.8114C11.7002 17.9865 11.4605 18.2579 11.3246 18.5833C11.1886 18.9087 11.1639 19.2699 11.2544 19.6108C11.3449 19.9516 11.5455 20.2531 11.825 20.4682C12.1045 20.6832 12.4473 20.8 12.8 20.8002V32.0002C12.3756 32.0002 11.9686 32.1687 11.6686 32.4688C11.3685 32.7689 11.2 33.1758 11.2 33.6002C11.2 34.0245 11.3685 34.4315 11.6686 34.7315C11.9686 35.0316 12.3756 35.2002 12.8 35.2002H35.1999C35.6243 35.2002 36.0313 35.0316 36.3313 34.7315C36.6314 34.4315 36.7999 34.0245 36.7999 33.6002C36.7999 33.1758 36.6314 32.7689 36.3313 32.4688C36.0313 32.1687 35.6243 32.0002 35.1999 32.0002V20.8002C35.5526 20.8 35.8954 20.6832 36.1749 20.4682C36.4544 20.2531 36.655 19.9516 36.7455 19.6108C36.836 19.2699 36.8113 18.9087 36.6753 18.5833C36.5394 18.2579 36.2997 17.9865 35.9936 17.8114L24.7936 11.4114V11.4114ZM17.6 22.4002C17.1756 22.4002 16.7686 22.5687 16.4686 22.8688C16.1685 23.1689 16 23.5758 16 24.0002V28.8002C16 29.2245 16.1685 29.6315 16.4686 29.9315C16.7686 30.2316 17.1756 30.4002 17.6 30.4002C18.0243 30.4002 18.4313 30.2316 18.7313 29.9315C19.0314 29.6315 19.2 29.2245 19.2 28.8002V24.0002C19.2 23.5758 19.0314 23.1689 18.7313 22.8688C18.4313 22.5687 18.0243 22.4002 17.6 22.4002ZM22.4 24.0002C22.4 23.5758 22.5685 23.1689 22.8686 22.8688C23.1686 22.5687 23.5756 22.4002 24 22.4002C24.4243 22.4002 24.8313 22.5687 25.1313 22.8688C25.4314 23.1689 25.6 23.5758 25.6 24.0002V28.8002C25.6 29.2245 25.4314 29.6315 25.1313 29.9315C24.8313 30.2316 24.4243 30.4002 24 30.4002C23.5756 30.4002 23.1686 30.2316 22.8686 29.9315C22.5685 29.6315 22.4 29.2245 22.4 28.8002V24.0002ZM30.4 22.4002C29.9756 22.4002 29.5686 22.5687 29.2686 22.8688C28.9685 23.1689 28.8 23.5758 28.8 24.0002V28.8002C28.8 29.2245 28.9685 29.6315 29.2686 29.9315C29.5686 30.2316 29.9756 30.4002 30.4 30.4002C30.8243 30.4002 31.2313 30.2316 31.5313 29.9315C31.8314 29.6315 31.9999 29.2245 31.9999 28.8002V24.0002C31.9999 23.5758 31.8314 23.1689 31.5313 22.8688C31.2313 22.5687 30.8243 22.4002 30.4 22.4002Z" fill="white" />
      </svg>,
      title: "Total Plants",
      count: "--",
    },
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#63C700" />
        <path d="M21.824 19.937C22.089 19.937 22.353 19.833 22.55 19.625C23.291 18.845 24.613 18.815 25.385 19.56C25.783 19.943 26.416 19.932 26.799 19.534C27.183 19.137 27.171 18.503 26.774 18.12C26.024 17.397 25.039 17 24 17C22.908 17 21.851 17.455 21.099 18.249C20.719 18.649 20.736 19.283 21.136 19.663C21.329 19.846 21.577 19.937 21.824 19.937Z" fill="white" />
        <path d="M31 21C31 17.14 27.859 14 24 14C20.141 14 17 17.14 17 21C15.346 21 14 22.346 14 24V26C14 27.654 15.346 29 17 29H18C18.553 29 19 28.552 19 28V21C19 18.243 21.243 16 24 16C26.757 16 29 18.243 29 21V28.083C29 29.692 27.691 31 26.083 31H26C26 29.897 25.103 29 24 29H23C21.897 29 21 29.897 21 31V32C21 33.103 21.897 34 23 34H24C24.737 34 25.375 33.595 25.722 33H26.083C28.48 33 30.476 31.273 30.907 29H31C32.654 29 34 27.654 34 26V24C34 22.346 32.654 21 31 21Z" fill="white" />
      </svg>,
      title: "Service Requests",
      count: "--",
    },
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#C70048" />
        <path d="M22.4001 17.5998C22.4001 18.8728 21.8944 20.0937 20.9942 20.9939C20.094 21.8941 18.8731 22.3998 17.6001 22.3998C16.3271 22.3998 15.1062 21.8941 14.206 20.9939C13.3058 20.0937 12.8001 18.8728 12.8001 17.5998C12.8001 16.3268 13.3058 15.1059 14.206 14.2057C15.1062 13.3055 16.3271 12.7998 17.6001 12.7998C18.8731 12.7998 20.094 13.3055 20.9942 14.2057C21.8944 15.1059 22.4001 16.3268 22.4001 17.5998V17.5998ZM35.2001 17.5998C35.2001 18.2302 35.0759 18.8543 34.8347 19.4367C34.5935 20.019 34.2399 20.5482 33.7942 20.9939C33.3485 21.4396 32.8193 21.7932 32.237 22.0344C31.6546 22.2757 31.0304 22.3998 30.4001 22.3998C29.7698 22.3998 29.1456 22.2757 28.5632 22.0344C27.9809 21.7932 27.4517 21.4396 27.006 20.9939C26.5603 20.5482 26.2067 20.019 25.9655 19.4367C25.7243 18.8543 25.6001 18.2302 25.6001 17.5998C25.6001 16.3268 26.1058 15.1059 27.006 14.2057C27.9062 13.3055 29.1271 12.7998 30.4001 12.7998C31.6731 12.7998 32.894 13.3055 33.7942 14.2057C34.6944 15.1059 35.2001 16.3268 35.2001 17.5998V17.5998ZM28.6881 35.1998C28.7617 34.6766 28.8001 34.1438 28.8001 33.5998C28.8038 31.086 27.9581 28.6446 26.4001 26.6718C27.6162 25.9697 28.9958 25.6 30.4 25.6C31.8043 25.6 33.1839 25.9696 34.4 26.6718C35.6162 27.3739 36.6261 28.3838 37.3282 29.5999C38.0304 30.816 38.4001 32.1955 38.4001 33.5998V35.1998H28.6881ZM17.6001 25.5998C19.7218 25.5998 21.7567 26.4427 23.257 27.943C24.7572 29.4432 25.6001 31.4781 25.6001 33.5998V35.1998H9.6001V33.5998C9.6001 31.4781 10.443 29.4432 11.9432 27.943C13.4435 26.4427 15.4784 25.5998 17.6001 25.5998V25.5998Z" fill="white" />
      </svg>,
      title: "Total Users",
      count: "--",
    },
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#6B7280" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2C18.3513 11.2 17.5374 11.5371 16.9373 12.1372C16.3371 12.7373 16 13.5513 16 14.4V33.5999C16 34.4486 16.3371 35.2626 16.9373 35.8627C17.5374 36.4628 18.3513 36.7999 19.2 36.7999H28.8C29.6487 36.7999 30.4626 36.4628 31.0627 35.8627C31.6629 35.2626 32 34.4486 32 33.5999V14.4C32 13.5513 31.6629 12.7373 31.0627 12.1372C30.4626 11.5371 29.6487 11.2 28.8 11.2H19.2ZM24 33.5999C24.4243 33.5999 24.8313 33.4314 25.1314 33.1313C25.4314 32.8313 25.6 32.4243 25.6 31.9999C25.6 31.5756 25.4314 31.1686 25.1314 30.8686C24.8313 30.5685 24.4243 30.4 24 30.4C23.5757 30.4 23.1687 30.5685 22.8686 30.8686C22.5686 31.1686 22.4 31.5756 22.4 31.9999C22.4 32.4243 22.5686 32.8313 22.8686 33.1313C23.1687 33.4314 23.5757 33.5999 24 33.5999V33.5999Z" fill="white" />
      </svg>,
      title: "Online Devices",
      count: "--",
    },
    {
      icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="8" fill="#111928" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2C18.3513 11.2 17.5374 11.5371 16.9373 12.1372C16.3371 12.7373 16 13.5513 16 14.4V33.5999C16 34.4486 16.3371 35.2626 16.9373 35.8627C17.5374 36.4628 18.3513 36.7999 19.2 36.7999H28.8C29.6487 36.7999 30.4626 36.4628 31.0627 35.8627C31.6629 35.2626 32 34.4486 32 33.5999V14.4C32 13.5513 31.6629 12.7373 31.0627 12.1372C30.4626 11.5371 29.6487 11.2 28.8 11.2H19.2ZM24 33.5999C24.4243 33.5999 24.8313 33.4314 25.1314 33.1313C25.4314 32.8313 25.6 32.4243 25.6 31.9999C25.6 31.5756 25.4314 31.1686 25.1314 30.8686C24.8313 30.5685 24.4243 30.4 24 30.4C23.5757 30.4 23.1687 30.5685 22.8686 30.8686C22.5686 31.1686 22.4 31.5756 22.4 31.9999C22.4 32.4243 22.5686 32.8313 22.8686 33.1313C23.1687 33.4314 23.5757 33.5999 24 33.5999V33.5999Z" fill="white" />
      </svg>,
      title: "Offline Devices",
      count: "--",
    },
  ]);
  const [deviceOptions, setDeviceOptions] = useState({});
  const [mapDevices, setMapDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [selectedDeviceStartDate, setSelectedDeviceStartDate] = useState("");
  const [selectedDeviceEndDate, setSelectedDeviceEndDate] = useState("");
  const [barGraphData, setBarGraphData] = useState({});
  const [deviceLogData, setDeviceLogData] = useState({});
  const [isSubmitting, setSubmitting] = useState(false);
  const [mapCenter, setMapCenter] = useState([18.5204, 73.8567]);


  function formatDateTime(dateTimeStr) {
    const dateTime = new Date(dateTimeStr);
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, '0');
    const day = String(dateTime.getDate()).padStart(2, '0');
    const hours = String(dateTime.getHours()).padStart(2, '0');
    const minutes = String(dateTime.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const respones = await getDeviceDropDownApi();
        if (respones?.status === 200) {
          setDeviceOptions(respones?.data);
        } else {
          let errors = "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      } catch (error) {
        let errors =
          error?.response?.data?.detail ||
          "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    };
    fetchData();
  }, []);

  const transformData = () => {
    const options = [];
    if (deviceOptions && deviceOptions) {
      for (let i = 0; i < deviceOptions.length; i++) {
        const item = deviceOptions[i];
        options.push({
          value: item.id,
          label: item.device_name,
        });
      }
    }
    return options;
  };

  // function to call device log api and set data
  const getDeviceLogData = async ({ deviceId }) => {
    // setSelectedDevice(deviceId);
    if (deviceId !== "") {
      setSubmitting(true);
      try {
        const response = await getDeviceLogsApi({ deviceId: deviceId, startDate: selectedDeviceStartDate, endDate: selectedDeviceEndDate, });
        setSubmitting(false);
        if (response?.status === 200) {
          const formattedData = response?.data.logs.map(entry => ({
            ...entry,
            formatted_created_at: formatDateTime(entry.created_at),
          }));

          setDeviceLogData(formattedData);
          setMapCenter([response?.data?.lat, response?.data?.lon]);
        } else {
          let errors = "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      } catch (e) {
        let errors =
          e?.response?.data?.detail ||
          "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const respones = await getDashboardApi();
        if (respones?.status === 200) {
          var data = respones?.data;
          setCardData([
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#1C64F2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2002C18.3513 11.2002 17.5374 11.5373 16.9373 12.1375C16.3371 12.7376 16 13.5515 16 14.4002V33.6002C16 34.4489 16.3371 35.2628 16.9373 35.8629C17.5374 36.4631 18.3513 36.8002 19.2 36.8002H28.8C29.6487 36.8002 30.4626 36.4631 31.0627 35.8629C31.6629 35.2628 32 34.4489 32 33.6002V14.4002C32 13.5515 31.6629 12.7376 31.0627 12.1375C30.4626 11.5373 29.6487 11.2002 28.8 11.2002H19.2ZM24 33.6002C24.4243 33.6002 24.8313 33.4316 25.1314 33.1316C25.4314 32.8315 25.6 32.4245 25.6 32.0002C25.6 31.5758 25.4314 31.1689 25.1314 30.8688C24.8313 30.5688 24.4243 30.4002 24 30.4002C23.5757 30.4002 23.1687 30.5688 22.8686 30.8688C22.5686 31.1689 22.4 31.5758 22.4 32.0002C22.4 32.4245 22.5686 32.8315 22.8686 33.1316C23.1687 33.4316 23.5757 33.6002 24 33.6002V33.6002Z" fill="white" />
              </svg>,
              title: "Total Devices",
              count: data.total_devices,
            },
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#F2831C" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7936 11.4114C24.5518 11.2733 24.2783 11.2007 24 11.2007C23.7216 11.2007 23.4481 11.2733 23.2063 11.4114L12.0064 17.8114C11.7002 17.9865 11.4605 18.2579 11.3246 18.5833C11.1886 18.9087 11.1639 19.2699 11.2544 19.6108C11.3449 19.9516 11.5455 20.2531 11.825 20.4682C12.1045 20.6832 12.4473 20.8 12.8 20.8002V32.0002C12.3756 32.0002 11.9686 32.1687 11.6686 32.4688C11.3685 32.7689 11.2 33.1758 11.2 33.6002C11.2 34.0245 11.3685 34.4315 11.6686 34.7315C11.9686 35.0316 12.3756 35.2002 12.8 35.2002H35.1999C35.6243 35.2002 36.0313 35.0316 36.3313 34.7315C36.6314 34.4315 36.7999 34.0245 36.7999 33.6002C36.7999 33.1758 36.6314 32.7689 36.3313 32.4688C36.0313 32.1687 35.6243 32.0002 35.1999 32.0002V20.8002C35.5526 20.8 35.8954 20.6832 36.1749 20.4682C36.4544 20.2531 36.655 19.9516 36.7455 19.6108C36.836 19.2699 36.8113 18.9087 36.6753 18.5833C36.5394 18.2579 36.2997 17.9865 35.9936 17.8114L24.7936 11.4114V11.4114ZM17.6 22.4002C17.1756 22.4002 16.7686 22.5687 16.4686 22.8688C16.1685 23.1689 16 23.5758 16 24.0002V28.8002C16 29.2245 16.1685 29.6315 16.4686 29.9315C16.7686 30.2316 17.1756 30.4002 17.6 30.4002C18.0243 30.4002 18.4313 30.2316 18.7313 29.9315C19.0314 29.6315 19.2 29.2245 19.2 28.8002V24.0002C19.2 23.5758 19.0314 23.1689 18.7313 22.8688C18.4313 22.5687 18.0243 22.4002 17.6 22.4002ZM22.4 24.0002C22.4 23.5758 22.5685 23.1689 22.8686 22.8688C23.1686 22.5687 23.5756 22.4002 24 22.4002C24.4243 22.4002 24.8313 22.5687 25.1313 22.8688C25.4314 23.1689 25.6 23.5758 25.6 24.0002V28.8002C25.6 29.2245 25.4314 29.6315 25.1313 29.9315C24.8313 30.2316 24.4243 30.4002 24 30.4002C23.5756 30.4002 23.1686 30.2316 22.8686 29.9315C22.5685 29.6315 22.4 29.2245 22.4 28.8002V24.0002ZM30.4 22.4002C29.9756 22.4002 29.5686 22.5687 29.2686 22.8688C28.9685 23.1689 28.8 23.5758 28.8 24.0002V28.8002C28.8 29.2245 28.9685 29.6315 29.2686 29.9315C29.5686 30.2316 29.9756 30.4002 30.4 30.4002C30.8243 30.4002 31.2313 30.2316 31.5313 29.9315C31.8314 29.6315 31.9999 29.2245 31.9999 28.8002V24.0002C31.9999 23.5758 31.8314 23.1689 31.5313 22.8688C31.2313 22.5687 30.8243 22.4002 30.4 22.4002Z" fill="white" />
              </svg>,
              title: "Total Plants",
              count: data.total_plants,
            },
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#63C700" />
                <path d="M21.824 19.937C22.089 19.937 22.353 19.833 22.55 19.625C23.291 18.845 24.613 18.815 25.385 19.56C25.783 19.943 26.416 19.932 26.799 19.534C27.183 19.137 27.171 18.503 26.774 18.12C26.024 17.397 25.039 17 24 17C22.908 17 21.851 17.455 21.099 18.249C20.719 18.649 20.736 19.283 21.136 19.663C21.329 19.846 21.577 19.937 21.824 19.937Z" fill="white" />
                <path d="M31 21C31 17.14 27.859 14 24 14C20.141 14 17 17.14 17 21C15.346 21 14 22.346 14 24V26C14 27.654 15.346 29 17 29H18C18.553 29 19 28.552 19 28V21C19 18.243 21.243 16 24 16C26.757 16 29 18.243 29 21V28.083C29 29.692 27.691 31 26.083 31H26C26 29.897 25.103 29 24 29H23C21.897 29 21 29.897 21 31V32C21 33.103 21.897 34 23 34H24C24.737 34 25.375 33.595 25.722 33H26.083C28.48 33 30.476 31.273 30.907 29H31C32.654 29 34 27.654 34 26V24C34 22.346 32.654 21 31 21Z" fill="white" />
              </svg>,
              title: "Service Requests",
              count: data.service_requests,
            },
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#C70048" />
                <path d="M22.4001 17.5998C22.4001 18.8728 21.8944 20.0937 20.9942 20.9939C20.094 21.8941 18.8731 22.3998 17.6001 22.3998C16.3271 22.3998 15.1062 21.8941 14.206 20.9939C13.3058 20.0937 12.8001 18.8728 12.8001 17.5998C12.8001 16.3268 13.3058 15.1059 14.206 14.2057C15.1062 13.3055 16.3271 12.7998 17.6001 12.7998C18.8731 12.7998 20.094 13.3055 20.9942 14.2057C21.8944 15.1059 22.4001 16.3268 22.4001 17.5998V17.5998ZM35.2001 17.5998C35.2001 18.2302 35.0759 18.8543 34.8347 19.4367C34.5935 20.019 34.2399 20.5482 33.7942 20.9939C33.3485 21.4396 32.8193 21.7932 32.237 22.0344C31.6546 22.2757 31.0304 22.3998 30.4001 22.3998C29.7698 22.3998 29.1456 22.2757 28.5632 22.0344C27.9809 21.7932 27.4517 21.4396 27.006 20.9939C26.5603 20.5482 26.2067 20.019 25.9655 19.4367C25.7243 18.8543 25.6001 18.2302 25.6001 17.5998C25.6001 16.3268 26.1058 15.1059 27.006 14.2057C27.9062 13.3055 29.1271 12.7998 30.4001 12.7998C31.6731 12.7998 32.894 13.3055 33.7942 14.2057C34.6944 15.1059 35.2001 16.3268 35.2001 17.5998V17.5998ZM28.6881 35.1998C28.7617 34.6766 28.8001 34.1438 28.8001 33.5998C28.8038 31.086 27.9581 28.6446 26.4001 26.6718C27.6162 25.9697 28.9958 25.6 30.4 25.6C31.8043 25.6 33.1839 25.9696 34.4 26.6718C35.6162 27.3739 36.6261 28.3838 37.3282 29.5999C38.0304 30.816 38.4001 32.1955 38.4001 33.5998V35.1998H28.6881ZM17.6001 25.5998C19.7218 25.5998 21.7567 26.4427 23.257 27.943C24.7572 29.4432 25.6001 31.4781 25.6001 33.5998V35.1998H9.6001V33.5998C9.6001 31.4781 10.443 29.4432 11.9432 27.943C13.4435 26.4427 15.4784 25.5998 17.6001 25.5998V25.5998Z" fill="white" />
              </svg>,
              title: "Total Users",
              count: data.total_users,
            },
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#6B7280" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2C18.3513 11.2 17.5374 11.5371 16.9373 12.1372C16.3371 12.7373 16 13.5513 16 14.4V33.5999C16 34.4486 16.3371 35.2626 16.9373 35.8627C17.5374 36.4628 18.3513 36.7999 19.2 36.7999H28.8C29.6487 36.7999 30.4626 36.4628 31.0627 35.8627C31.6629 35.2626 32 34.4486 32 33.5999V14.4C32 13.5513 31.6629 12.7373 31.0627 12.1372C30.4626 11.5371 29.6487 11.2 28.8 11.2H19.2ZM24 33.5999C24.4243 33.5999 24.8313 33.4314 25.1314 33.1313C25.4314 32.8313 25.6 32.4243 25.6 31.9999C25.6 31.5756 25.4314 31.1686 25.1314 30.8686C24.8313 30.5685 24.4243 30.4 24 30.4C23.5757 30.4 23.1687 30.5685 22.8686 30.8686C22.5686 31.1686 22.4 31.5756 22.4 31.9999C22.4 32.4243 22.5686 32.8313 22.8686 33.1313C23.1687 33.4314 23.5757 33.5999 24 33.5999V33.5999Z" fill="white" />
              </svg>,
              title: "Online Devices",
              count: data.online_devices ?? "--",
            },
            {
              icon: <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill="#111928" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 11.2C18.3513 11.2 17.5374 11.5371 16.9373 12.1372C16.3371 12.7373 16 13.5513 16 14.4V33.5999C16 34.4486 16.3371 35.2626 16.9373 35.8627C17.5374 36.4628 18.3513 36.7999 19.2 36.7999H28.8C29.6487 36.7999 30.4626 36.4628 31.0627 35.8627C31.6629 35.2626 32 34.4486 32 33.5999V14.4C32 13.5513 31.6629 12.7373 31.0627 12.1372C30.4626 11.5371 29.6487 11.2 28.8 11.2H19.2ZM24 33.5999C24.4243 33.5999 24.8313 33.4314 25.1314 33.1313C25.4314 32.8313 25.6 32.4243 25.6 31.9999C25.6 31.5756 25.4314 31.1686 25.1314 30.8686C24.8313 30.5685 24.4243 30.4 24 30.4C23.5757 30.4 23.1687 30.5685 22.8686 30.8686C22.5686 31.1686 22.4 31.5756 22.4 31.9999C22.4 32.4243 22.5686 32.8313 22.8686 33.1313C23.1687 33.4314 23.5757 33.5999 24 33.5999V33.5999Z" fill="white" />
              </svg>,
              title: "Offline Devices",
              count: data.offline_devices ?? "--",
            },
          ]);
          const transformedData = data.device_count_by_state.map(e => ({
            state: e.plant__state,
            count: e.device_count,
          }));
          setBarGraphData(transformedData);
          const latLngs = data.device_data
            .filter(e => e.lat !== "" && e.lng !== "")
            .map(e => ({
              lat: parseFloat(e.lat),
              lng: parseFloat(e.lon),
              label: `${e.device_name} [${e.is_active ? "Online" : "Offline"}]`,
            }));
          setMapDevices(latLngs);
        } else {
          let errors = "Opps! Something went wrong, please try again.";
          showAlert("Error", errors, "error");
        }
      } catch (error) {
        let errors =
          error?.response?.data?.detail ||
          "Opps! Something went wrong, please try again.";
        showAlert("Error", errors, "error");
      }
    };
    fetchData();
  }, []);

  const handleFormSubmit = async (values) => {
    // selectedDeviceStartDate(values.from_date);
    // setSelectedDeviceEndDate(values.to_date);
    getDeviceLogData({ deviceId: values.device, });
  };

  return (
    <>
      <div className="flex gap-3 items-center font-medium text-gray-500" >
        <AiFillHome />
        <p>Home</p>
        <IoIosArrowForward />
        <p>Dashboard</p>
      </div>
      <div className="py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {cardData.map((card, index) => (
            <Card title={card.title} count={card.count} icon={card.icon} />
          ))}
        </div>
      </div>
      <div className="bg-white mt-4 w-full p-4 flex-col rounded-lg">
        <StyledHeadingText text="PLANTS GRAPH" />
        <DashboardBarGraph data={barGraphData} />
      </div>
      <div className="bg-white mt-4 w-full p-4 flex-col rounded-lg">
        <div className="mt-8">
          <Formik
            enableReinitialize={true}
            initialValues={{
              device: selectedDevice,
              from_date: selectedDeviceStartDate,
              to_date: selectedDeviceEndDate,
            }}
            onSubmit={handleFormSubmit}
          >
            {({ resetForm }) => (
              <Form>
                <div className="flex flex-row items-start w-full border-gray-300 p-4 rounded-lg bg-gray-100 border">
                  <div className="flex-1 ml-5">
                    <div className="w-full mb-1">
                      <div className="grid gap-6 md:grid-cols-3">
                        <Select
                          label="DEVICE"
                          name="device"
                          options={transformData()}
                          false
                          needSearch={true}
                        />
                        <InputField
                          label="FROM DATE"
                          name="from_date"
                          type="date"
                          placeholder="DD-MM-YYYY"
                          false
                        />

                        <InputField
                          label="TO DATE"
                          name="to_date"
                          type="date"
                          placeholder="DD-MM-YYYY"
                          false
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-5 flex justify-end gap-6">
                  <div>
                    <Button
                      type="submit"
                      className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Applying..." : "Apply"}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="mt-5 flex flex-row">
        <div className="flex-1 bg-white mt-4 w-full p-4 flex-col rounded-lg border border-gray-300">
          <MapComponent positions={mapDevices} mapLocation={mapCenter} />
        </div>
        <div className="mr-5"></div>
        <div className="flex-1 bg-white mt-4 w-full p-4 flex-col rounded-lg border border-gray-300">
          <DashboardLineChart data={deviceLogData} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
